import React from 'react';
import AppRouter from './routes/AppRouter';

export default function Main() {
  return (
    <AppRouter/>
  )
}







